import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

/**
 * Submissions hub container (same shape as the Analytics hub): the Queue
 * (the original page, unchanged) and the Breakdown as subtabs. Old
 * bookmarks to /dashboard/submissions land on the Queue. No platform-flag
 * gating at route level — both subtabs are valid in every mode.
 */
const SubmissionsHub: React.FC = () => {
	const routeGroup = useRouteGroup('submissions');
	const { path, url } = useRouteMatch();
	useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/submissions',
		routeGroup: routeGroup,
		routePlacement: 2,
	});

	return (
		<Switch>
			{routeGroup && !Array.isArray(routeGroup) && (
				<>
					{/* Redirect must be wrapped in a Route — bare Redirects inside a
					    fragment fire unconditionally (see ClassRooms.tsx). */}
					<Route exact path={url}>
						<Redirect to={`${url}/queue`} />
					</Route>
					{routeGroup.routes.map((_) => (
						<Route key={_.route} strict path={`${path}/${_.route}`}>
							{_.component}
						</Route>
					))}
				</>
			)}
		</Switch>
	);
};

export default SubmissionsHub;
